import React, { FC } from 'react'

import { IconChatProps } from './IconChat.types'
import * as Styled from './styles/IconChat.style'

import { nonThemeableRules } from '../../ruleSet'

const IconChat: FC<IconChatProps> = ({
  size = nonThemeableRules.defaultSize as number as IconChatProps['size'],
  isResponsive = false,
}: IconChatProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M35.81 18.82c.082-2.178-1.148-4.07-1.333-4.335a12.294 12.294 0 0 0-3.542-3.658 16.026 16.026 0 0 0-5.025-2.275 19.373 19.373 0 0 0-11.873.73 16.314 16.314 0 0 0-4.75 2.868 12.669 12.669 0 0 0-3.162 4.075 10.153 10.153 0 0 0-1 4.915 9.922 9.922 0 0 0 .672 3.135c.396.99.936 1.918 1.603 2.75a12.707 12.707 0 0 0 2.35 2.27 16.649 16.649 0 0 0 2.873 1.53c-1.313 2.25-3.563 3.625-3.588 3.637a.945.945 0 0 0 .405 1.75c.455.035.91.055 1.365.055a16.09 16.09 0 0 0 5.445-.94c.045-.015 1.063-.385 3.8-1.875'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M42.888 27.41a8.082 8.082 0 0 0-1.203-3.84 9.476 9.476 0 0 0-1.75-2.078l-.03-.024a15.54 15.54 0 0 0-4.475-2.5h-.038l-.547-.17c-3.12-.803-6.412-.6-9.41.577a13.04 13.04 0 0 0-3.777 2.29 10.168 10.168 0 0 0-2.526 3.25 8.198 8.198 0 0 0-.817 3.963 8.085 8.085 0 0 0 1.212 3.83 9.87 9.87 0 0 0 2.833 2.95 12.614 12.614 0 0 0 4 1.812c1.49.394 3.033.553 4.573.473.456.296.93.566 1.417.807.723.35 1.476.633 2.25.845.897.25 1.82.397 2.75.438h.532c.893 0 1.783-.093 2.656-.278a.945.945 0 0 0 .285-1.75c-.923-.538-2.173-1.547-2.583-2.403.57-.377 1.107-.802 1.605-1.27A10.585 10.585 0 0 0 41.53 32.3a8.88 8.88 0 0 0 1.05-2.347 8.15 8.15 0 0 0 .308-2.543v0Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconChat
